<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span> User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check</span>
        <router-link :to="{ name: 'page-user-list' }" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="user-data">
      <vx-card title="Información del caso">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Código</td>
                <td>{{ casoData.id }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Proyecto</td>
                <td>{{ casoData.proyecto.descripcion }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Subproyecto</td>
                <td>{{ casoData.subproyecto && casoData.subproyecto.descripcion ? casoData.subproyecto.descripcion : '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Estado</td>
                <td>{{ casoData.descRequestStatus }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Fecha<br>creación</td>
                <td>{{ casoData.fechaRegistro }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Grupo tipo caso</td>
                <td>{{ casoData.groupTipCaso && casoData.groupTipCaso.descripcion ? casoData.groupTipCaso.descripcion : '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Tipo caso</td>
                <td>{{ casoData.tipoActividad ? casoData.tipoActividad.descripcion : '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ company.nameCompany === companiesEnumsData.BRILLA ? 'Aranda' : 'Código externo' }}</td>
                <td>{{ casoData.codigoInterno }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ company.nameCompany === companiesEnumsData.BRILLA ? 'Agente' : 'Usuario registra' }}</td>
                <td>{{ casoData.usuarioReg +' - '+ casoData.nameUserReg }}</td>
              </tr>
            </table>
          </div>

          <!-- /Information - Col 2 -->
          <!-- <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              @click="openEdit"
              >Modificar</vs-button
            >
            <vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              @click="confirmDeleteRecord"
              >Eliminar</vs-button
            >
          </div> -->
        </div>
        <table>
          <tr>
            <td class="font-semibold">Descripción</td>
            <td>{{ casoData.descripcion }}</td>
          </tr>
        </table>
      </vx-card>

      <!-- icon="icon-edit" -->
      <div v-if="casoData.estado !== 4" class="vx-col w-full flex mt-6" id="account-manage-buttons">
        <vs-button v-if="casoData.estado === 4" class="mr-4" icon-pack="feather" @click="activePromptM(1, 'Aceptar solución caso')">Aceptar
          solución</vs-button>
        <vs-button v-if="casoData.estado === 7" class="mr-4" type="border" color="warning" icon-pack="feather"
          @click="activePromptM(2, 'Devolver caso cliente')">Devolver caso cliente</vs-button>

        <vs-dropdown v-if="casoData.estado !== 4" vs-custom-content class="cursor-pointer">
          <vs-button
            v-if="can('gecoaca_more_actions') || gecoaca_more_actions_by_user"
            type="border"
            icon-pack="feather">Más acciones</vs-button>

          <vs-dropdown-menu class="vx-navbar-dropdown">
            <ul style="min-width: 15rem">
              <vs-dropdown-item
                class="py-1"
                @click="activePromptM(3, 'Escalar usuario')"
              >
                <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Escalar usuario</span>
              </vs-dropdown-item>

              <vs-divider class="m-1" />

              <vs-dropdown-item
                class="py-1"
                @click="activePromptM(4, 'Escalar servicio')"
              >
                <feather-icon icon="RefreshCwIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Escalar servicio</span>
              </vs-dropdown-item>

              <vs-divider class="m-1" />

              <vs-dropdown-item
                class="py-1"
                @click="activePromptM(5, 'Cambiar criticidad')">
                <feather-icon icon="ZapIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Cambiar criticidad</span>
              </vs-dropdown-item>

              <div v-if="casoData.estado !== 7">

                <vs-divider class="m-1" />

                <vs-dropdown-item
                  class="py-1"
                  @click="activePromptM(6, 'Devolver caso usuario')">
                  <feather-icon icon="RotateCcwIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Devolver caso usuario</span>
                </vs-dropdown-item>
              </div>

              <!-- <vs-divider class="m-1" /> -->

              <!-- <vs-dropdown-item
                class="py-1"
                @click="activePromptM(6, 'Cambiar prioridad')">
                <feather-icon icon="StarIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Cambiar prioridad</span>
              </vs-dropdown-item> -->
            </ul>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <vx-card class="mt-6">
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-center px-3">
              <feather-icon svgClasses="w-6 h-6" icon="ListIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Detalles</span>
            </div>
            <vs-divider />
          </div>
        </div>

        <vs-tabs>
          <vs-tab label="Etapas">
            <div class="block overflow-x-auto">
              <etapa-caso-list-view :casoProp="casoData" v-if="casoData !== undefined"></etapa-caso-list-view>
            </div>
          </vs-tab>
          <vs-tab label="Observaciones">
            <div class="block overflow-x-auto">
              <observacion-caso-list-view :casoProp="casoData" v-if="casoData !== undefined">
              </observacion-caso-list-view>
            </div>
          </vs-tab>
          <vs-tab label="Archivos adjuntos">
            <div class="block overflow-x-auto">
              <archivo-adjunto-caso-list-view :casoProp="casoData" v-if="casoData !== undefined">
              </archivo-adjunto-caso-list-view>
            </div>
          </vs-tab>
          <!-- <vs-tab label="Proponentes">
            <div class="block overflow-x-auto">
              <proponente-list-view
                :casoProp="casoData"
                v-if="casoData !== undefined"
              ></proponente-list-view>
            </div>
          </vs-tab> -->
        </vs-tabs>
      </vx-card>
    </div>

    <vs-prompt :color="activePromptOption === 2 ? 'warning' : 'success'"
      @cancel="valMultipe.value1 = '', valMultipe.value2 = 'Y', valMultipe.value3 = '', valMultipe.value4 = '', valMultipe.value5 = ''" @accept="acceptAlert" @close="close"
      :title="promptTitle" acceptText="Aceptar"
      cancelText="Cancelar" :is-valid="validObservation" :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <p>Ingresa la observación para <b>continuar</b>.</p>
        <vs-textarea class="mt-6 mb-0 w-full" placeholder="Observación" v-model="valMultipe.value1" />
        <span
          class="text-danger text-sm"
          v-show="
            errors.has('valMultipe.value1') || formerr.includes('valMultipe.value1')
          "
          >Por favor digite la observación</span
        >

        <!-- Aceptar solución caso -->
        <div v-if="activePromptOption === 1">
          <p class="mt-3">Selecciona si desea aceptar o cancelar la solución.</p>
          <vs-checkbox class="mt-4" :disabled="valMultipe.value2 === 'Y' ? true : false"
            :value="valMultipe.value2 === 'Y' ? true : false" v-on:change="chageValue2('Y')">
            Aceptar solución
          </vs-checkbox>
          <vs-checkbox class="mt-4" :disabled="valMultipe.value2 === 'N' ? true : false"
            :value="valMultipe.value2 === 'N' ? true : false" v-on:change="chageValue2('N')" color="warning">
            Rechazar solución
          </vs-checkbox>
        </div>

        <!-- Escalar usuario -->
        <div v-if="activePromptOption === 3">
          <p class="mt-3">Selecciona el usuario nuevo.</p>
          <vs-select
              v-model="valMultipe.value3"
              name="valMultipe.value3"
              label="Usuarios"
              class="w-full mt-4"
            >
              <vs-select-item />
              <vs-select-item
                :key="item.id"
                :value="item.id"
                :text="item.descripcion"
                v-for="item in resource_by_projectList"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="
                errors.has('valMultipe.value3') || formerr.includes('valMultipe.value3')
              "
              >Por favor seleccione el usuario</span
            >
        </div>

        <!-- Escalar servicio -->
        <div v-if="activePromptOption === 4">
          <p class="mt-3">Selecciona el tipo de servicio.</p>
          <vs-select
              v-model="valMultipe.value4"
              name="valMultipe.value4"
              label="Tipos de servicio"
              class="w-full mt-4"
            >
              <vs-select-item />
              <vs-select-item
                :key="item.id"
                :value="item.id"
                :text="item.descripcion"
                v-for="item in servicetype_by_casetypeList"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="
                errors.has('valMultipe.value4') || formerr.includes('valMultipe.value4')
              "
              >Por favor seleccione el tipo de caso</span
            >
        </div>

        <!-- Cambiar criticidad -->
        <div v-if="activePromptOption === 5">
          <p class="mt-3">Selecciona la criticidad.</p>
          <vs-select
              v-model="valMultipe.value5"
              name="valMultipe.value5"
              label="Criticidades"
              class="w-full mt-4"
            >
              <vs-select-item />
              <vs-select-item
                :key="item.id"
                :value="item.id"
                :text="item.descripcion"
                v-for="item in criticality_by_casetypeList"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="
                errors.has('valMultipe.value5') || formerr.includes('valMultipe.value5')
              "
              >Por favor seleccione la criticidad</span
            >
        </div>
      </div>
    </vs-prompt>

    <vs-prompt color="success" @accept="this.closeConfirmDialog" @cancel="this.closeConfirmDialog"
      @close="this.closeConfirmDialog" :title="'Aviso'" acceptText="Aceptar" cancelText="Cancelar"
      :active.sync="activePrompt2">
      <div class="con-exemple-prompt">
        <p>{{ this.infoConfirmText }}</p>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import CasoModule from '@/store/caso-module/moduleDataList.js'
import EtapaCasoModule from '@/store/etapa-caso-module/moduleDataList.js'
import ListasModule from '@/store/listas-module/moduleDataList.js'
import EtapaCasoListView from '@/views/etapa-caso/EtapaCasoListView.vue'
import ObservacionCasoModule from '@/store/observacion-caso-module/moduleDataList.js'
import ObservacionCasoListView from '@/views/observacion-caso/ObservacionCasoListView.vue'
import ArchivoAdjuntoCasoModule from '@/store/archivo-adjunto-caso-module/moduleDataList.js'
import ArchivoAdjuntoCasoListView from '@/views/archivo-adjunto-caso/ArchivoAdjuntoCasoListView.vue'
import { VueContext } from 'vue-context'
import {companiesEnums, searchCompany} from '../../config/companies.js'
import can from '../../helpers/can.js'

export default {
  components: {
    EtapaCasoListView,
    ObservacionCasoListView,
    ArchivoAdjuntoCasoListView,
    VueContext
    // OfertaListView,
    // ProponenteListView,
  },
  props: {
    casoData: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      formerr: [], // Crear => true/Modificar => false
      user_data: {},
      user_not_found: false,
      company: null,
      activePrompt: false,
      activePrompt2: false,
      valMultipe: {
        value1: '',
        value2: 'Y',
        value3: '',
        value4: '',
        value5: ''
      },
      activePromptOption: 0,
      promptTitle: '',
      infoConfirmText: '',
      menuData: [
        { icon: 'PlusIcon', text: 'New' },
        { icon: 'FileIcon', text: 'Open' },
        { icon: 'SaveIcon', text: 'Save' },
        { icon: 'SaveIcon', text: 'Save As' },
        { icon: 'XIcon', text: 'Close' }
      ],
      can,
      companiesEnumsData: companiesEnums
    }
  },
  computed: {
    userAddress () {
      let str = ''
      for (const field in this.user_data.location) {
        str += `${field} `
      }
      return str
    },
    validateForm () {
      return !this.errors.any() && this.formerr.length <= 0
    },
    validObservation () {
      return (this.valMultipe.value1 && this.valMultipe.value1.length > 0)
    },
    resource_by_projectList () {
      return this.$store.state.ListasModule.resource_by_project
    },
    servicetype_by_casetypeList () {
      return this.$store.state.ListasModule.servicetype_by_casetype
    },
    criticality_by_casetypeList () {
      return this.$store.state.ListasModule.criticality_by_casetype
    },
    gecoaca_more_actions_by_user () {
      const user = this.$store.state.auth.userDetails()
      const caso = this.casoData

      console.log('casoData', caso)
      console.log('casoUsuario', user)

      if ((user && caso) && (user.is_leader === 'Y' || user.id === caso.usuarioReg)) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.company = searchCompany(this.$route.params.nameCompany)

    console.log('casoData', this.casoData)

    if (!CasoModule.isRegistered) {
      this.$store.registerModule('CasoModule', CasoModule)
      CasoModule.isRegistered = true
    }
    if (!EtapaCasoModule.isRegistered) {
      this.$store.registerModule('EtapaCasoModule', EtapaCasoModule)
      EtapaCasoModule.isRegistered = true
    }
    if (!ObservacionCasoModule.isRegistered) {
      this.$store.registerModule('ObservacionCasoModule', ObservacionCasoModule)
      ObservacionCasoModule.isRegistered = true
    }
    if (!ArchivoAdjuntoCasoModule.isRegistered) {
      this.$store.registerModule('ArchivoAdjuntoCasoModule', ArchivoAdjuntoCasoModule)
      ArchivoAdjuntoCasoModule.isRegistered = true
    }
    if (!ListasModule.isRegistered) {
      this.$store.registerModule('ListasModule', ListasModule)
      ListasModule.isRegistered = true
    }

    //Caso
    this.$store.dispatch('CasoModule/setCasoById', this.casoData)
    //Etapas
    const phases = this.casoData ? this.casoData.phases : []
    this.$store.dispatch('EtapaCasoModule/setAllEtapasCaso', phases)
    //Observaciones
    const requestObservations = this.casoData ? this.casoData.requestObservations : []
    this.$store.dispatch('ObservacionCasoModule/setAllObservacionesCaso', requestObservations)
    //Archivos Adjuntos
    const requestAttachments = this.casoData ? this.casoData.requestAttachments : []
    this.$store.dispatch('ArchivoAdjuntoCasoModule/setAllArchivosAdjuntosCaso', requestAttachments)

    // Lista de usuarios
    this.$vs.loading()
    this.$store
      .dispatch('ListasModule/getResourceByProject',
        {
          ...this.company,
          idUser: this.$store.state.auth.userDetails().id,
          idProject: this.casoData.proyecto ? this.casoData.proyecto.id : -1
        })
      .then(() => {
        this.$vs.loading.close()

      })
      .catch(() => {
        this.$vs.loading.close()
      })

    const idRequestType = this.casoData.tipoActividad ? this.casoData.tipoActividad.id : ''
    const idRequestTypeCriticality = this.casoData.criticality ? this.casoData.criticality.id : ''

    // Lista de Tipos de servicio
    this.$vs.loading()
    this.$store
      .dispatch('ListasModule/getTipServicioByTipoCaso',
        {
          ...this.company,
          idRequestType,
          idUser: this.$store.state.auth.userDetails().id,
          idProject: this.casoData.proyecto ? this.casoData.proyecto.id : -1
        })
      .then(() => {
        this.$vs.loading.close()

      })
      .catch(() => {
        this.$vs.loading.close()
      })

    // Lista de criticidad
    this.$vs.loading()
    this.$store
      .dispatch('ListasModule/getCriticidadByTipoCaso',
        {
          ...this.company,
          idRequestType,
          idRequestTypeCriticality,
          idUser: this.$store.state.auth.userDetails().id,
          idProject: this.casoData.proyecto ? this.casoData.proyecto.id : -1
        })
      .then(() => {
        this.$vs.loading.close()

      })
      .catch(() => {
        this.$vs.loading.close()
      })
  },
  methods: {
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar eliminar',
        text: `¿Desea eliminar la empresa "${this.casoData.name}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar',
        cancelText: 'Cancelar'
      })
    },
    openEdit () {
      this.$emit('changeMode')
    },
    displayMessage () {
      this.$vs.dialog({
        color: 'primary',
        title: 'Modificar registro',
        text: `Modificación de empresa id=${this.casoData.id}`,
        accept: console.log('texto')
      })
    },
    deleteRecord () {
      const idLicitacionTmp = this.casoData.id
      const nameLicitacionTmp = this.casoData.name
      this.$store
        .dispatch('CasoModule/removeCaso', idLicitacionTmp)
        .then(() => {
          this.$emit('closeView')
          this.$vs.notify({
            color: 'success',
            title: 'Caso eliminado',
            text: 'El caso ha sido eliminado del sistema.'
          })
        })
        .catch((ex) => {
          if (
            ex.data !== null &&
            ex.data !== undefined &&
            ex.data.nuOK !== -1
          ) {
            this.$vs.dialog({
              color: 'warning',
              title: 'Información',
              text: ex.data.errorDesc,
              acceptText: 'Aceptar'
            })
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text: 'No es posible consultar la base de datos',
              acceptText: 'Aceptar',
              accept: console.log('Ex:', ex)
            })
          }
        })
    },
    openList () {
      this.$refs.menu.open
    },
    activePromptM (option, title) {
      const idUser = this.$store.state.auth.userDetails().id
      const caso = this.casoData

      console.log(`usuario 1, ${idUser}`)
      console.log(`usuario 2, ${caso.usuario}`)

      if (caso.usuario === idUser) {
        this.activePrompt = true
        this.activePromptOption = option
        this.promptTitle = title
      } else {
        this.$vs.dialog({
          color: 'danger',
          title: 'Error',
          text:
            'El usuario no tiene asignado el caso para realizar esta acción.',
          acceptText: 'Aceptar'
        })
      }

    },
    acceptAlert () {
      this.activePrompt = true
      const idRequest = this.casoData.id
      const idUser = this.$store.state.auth.userDetails().id
      const idUserNew = this.valMultipe.value3
      const observation = this.valMultipe.value1
      const idServiceRequestTypeNew = this.valMultipe.value4
      const idRequestTypeCriticality = this.valMultipe.value5

      this.formerr = []

      if (
        this.valMultipe.value1 === null ||
        this.valMultipe.value1 === undefined ||
        this.valMultipe.value1 === ''
      ) {
        this.formerr.push('valMultipe.value1')
      }

      if (this.activePromptOption === 3) {
        if (
          this.valMultipe.value3 === null ||
        this.valMultipe.value3 === undefined ||
        this.valMultipe.value3 === ''
        ) {
          this.formerr.push('valMultipe.value3')
        }
      }

      // Aqui es cuando se oprime aceptar al escalar el caso
      if (this.activePromptOption === 4) {
        if (
          this.valMultipe.value4 === null ||
        this.valMultipe.value4 === undefined ||
        this.valMultipe.value4 === ''
        ) {
          this.formerr.push('valMultipe.value4')
        }
      }

      if (this.activePromptOption === 5) {
        if (
          this.valMultipe.value5 === null ||
        this.valMultipe.value5 === undefined ||
        this.valMultipe.value5 === ''
        ) {
          this.formerr.push('valMultipe.value5')
        }
      }

      if (this.validateForm) {
        this.activePrompt = false

        this.$vs.loading()
        // Aceptar solución
        if (this.activePromptOption === 1) {
          this.$store
            .dispatch('CasoModule/apruebaCierreCaso', {
              idRequest,
              idUser,
              observation,
              aprobado: this.valMultipe.value2
            })
            .then((response) => {
              this.$vs.loading.close()
              if (response) {
                this.activePrompt2 = true
                this.infoConfirmText = 'La solución se aceptó con éxito.'
              } else {
                this.showErrorMessage()
              }
            })
            .catch((response) => {
              console.log('getCasoById response error,', response)
              this.$vs.loading.close()

              this.showErrorMessage()
            })
        }
        // Devolver caso cliente
        if (this.activePromptOption === 2) {
          this.$store
            .dispatch('CasoModule/devolverInformacionCaso', {
              idRequest,
              idUser,
              observation
            })
            .then((response) => {
              this.$vs.loading.close()
              if (response) {
                this.activePrompt2 = true
                this.infoConfirmText = 'El caso se devolvió con éxito.'
              } else {
                this.showErrorMessage()
              }
            })
            .catch((response) => {
              console.log('getCasoById response error,', response)
              this.$vs.loading.close()

              this.showErrorMessage()
            })
        }
        // Escalar usuario
        if (this.activePromptOption === 3) {
          this.$store
            .dispatch('CasoModule/escalarUsuarioCaso', {
              idRequest,
              idUser,
              idUserNew,
              observation
            })
            .then((response) => {
              this.$vs.loading.close()
              if (response) {
                this.activePrompt2 = true
                this.infoConfirmText = 'El caso se escaló con éxito.'
              } else {
                this.showErrorMessage()
              }
            })
            .catch((response) => {
              console.log('getCasoById response error,', response)
              this.$vs.loading.close()

              this.showErrorMessage()
            })
        }
        // Escalar servicio
        if (this.activePromptOption === 4) {
          this.$store
            .dispatch('CasoModule/escalarServicioCaso', {
              idRequest,
              idUser,
              idServiceRequestTypeNew,
              observation
            })
            .then((response) => {
              this.$vs.loading.close()
              if (response) {
                this.activePrompt2 = true
                this.infoConfirmText = 'El caso se escaló con éxito.'
              } else {
                this.showErrorMessage()
              }
            })
            .catch((response) => {
              console.log('Escalar servicio response error,', response)
              this.$vs.loading.close()

              this.showErrorMessage()
            })
        }
        // Cambiar criticidad
        if (this.activePromptOption === 5) {
          this.$store
            .dispatch('CasoModule/cambiarCriticidadCaso', {
              idRequest,
              idUser,
              idRequestTypeCriticality,
              observation
            })
            .then((response) => {
              this.$vs.loading.close()
              if (response) {
                this.activePrompt2 = true
                this.infoConfirmText = 'Se cambió la criticidad del caso con éxito.'
              } else {
                this.showErrorMessage()
              }
            })
            .catch((response) => {
              console.log('Cambiar criticidad response error,', response)
              this.$vs.loading.close()

              this.showErrorMessage()
            })
        }
        // Devolver caso usuario
        if (this.activePromptOption === 6) {
          this.$store
            .dispatch('CasoModule/devolverCasoUsuario', {
              idRequest,
              idUser,
              observation
            })
            .then((response) => {
              this.$vs.loading.close()
              if (response) {
                this.activePrompt2 = true
                this.infoConfirmText = 'Se devolvió el caso con éxito.'
              } else {
                this.showErrorMessage()
              }
            })
            .catch((response) => {
              console.log('Devolver caso response error,', response)
              this.$vs.loading.close()

              this.showErrorMessage()
            })
        }

        this.resetValMultipe()
      }
    },
    close () {
      this.formerr = []
      this.activePrompt = false
      this.resetValMultipe()
    },
    resetValMultipe () {
      this.valMultipe = {
        value1: '',
        value2: 'Y',
        value3: '',
        value4: '',
        value5: ''
      }
    },
    showErrorMessage () {
      this.$vs.dialog({
        color: 'danger',
        title: 'Error',
        text:
                'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
        acceptText: 'Aceptar'
      })
    },
    closeConfirmDialog () {
      location.reload()
    },
    chageValue2 (value) {
      console.log('chageValue2 value, ', value)
      this.valMultipe = {
        value2: value
      }
    }
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
